import React, { Fragment } from 'react';
import DocumentTitle from 'react-document-title';

import AboutUsPAge from '../components/company/about-us-page/about-us-page';

const AboutUsRoute = () => (
  <Fragment>
    <DocumentTitle title="About Us | NerdWallet" />
    <AboutUsPAge />
  </Fragment>
);

AboutUsRoute.displayName = 'AboutUsRoute';
AboutUsRoute.analyticsName = 'about_us_page';

export default AboutUsRoute;
